import { useMemo } from 'react'

const ParticlesBackground = () => {
    const particles = useMemo(() => {
        return Array.from({ length: 20 }).map((_, i) => ({
            id: i,
            left: `${Math.random() * 100}%`,
            size: `${Math.random() * 4 + 2}px`,
            duration: `${Math.random() * 12 + 10}s`,
            delay: `${Math.random() * 20}s`,
            opacity: Math.random() * 0.08 + 0.04
        }))
    }, [])

    return (
        <div className="particles-container">
            {particles.map((p) => (
                <div
                    key={p.id}
                    className="particle"
                    style={{
                        left: p.left,
                        width: p.size,
                        height: p.size,
                        animationDuration: p.duration,
                        animationDelay: p.delay,
                        opacity: p.opacity
                    }}
                />
            ))}
        </div>
    )
}

export default ParticlesBackground
